import { useEffect } from 'react';
import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';
import useHomeStore from '../../../../store/homeStore';
import useAuthStore from '../../../../store/authStore';
import useCartStore from '../../../../store/cartStore';
import useSearchStore from '../../../../store/searchStore';

const useHeaderState = () => {
  const setSearchId = useSearchStore(state => state.setSearchId);
  const setShoppingItems = useCartStore(state => state.setShoppingItems);
  const {
    showPricingModal,
    showContactModal,
    setShowCart,
    showCart,
    setShowLogin,
    showLogin,
    showDownloadApiModal,
    showAdvertisingBanner,
    showFeaturesModal,
    advertisingBannerButtonText,
  } = useHomeStore();

  const isAuthenticated = useAuthStore(state => state.isAuthenticated());
  const shoppingCart = useGetShoppingCartQuery();

  useEffect(() => {
    if (isAuthenticated) {
      shoppingCart.refetch();
    }
  }, [isAuthenticated]);

  useEffect(() => {
    const data = shoppingCart.data;
    if (!data) return;
    setShoppingItems(data.shoppingItems);
  }, [shoppingCart.data, setShoppingItems]);

  const handleCart = () => {
    if (isAuthenticated) {
      setShowCart(!showCart);
    } else {
      setShowLogin(!showLogin);
    }
  };

  return {
    showPricingModal,
    showContactModal,
    showDownloadApiModal,
    showFeaturesModal,
    showCart,
    showLogin,
    advertisingBannerButtonText,
    isAuthenticated,
    shoppingCart,
    handleCart,
    setSearchId,
    showAdvertisingBanner,
  };
};

export default useHeaderState;
